import Logo from "assets/auth/Logo.png";
import Auth from "assets/auth/Auth.png";
import { ErrorMessage, Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SyncLoader } from "react-spinners";
import { apiReq } from "services/Requests";
import { API_ROUTES } from "utils/apiRoutes.constant";
import { Button } from "../../reusable/button/Button";
import {
  ForgetPasswordWrapper,
  LoginMessageWrapper,
} from "../signin/Signin.style";
import {
  AuthPicWrapper,
  FieldWrapper,
  FormLogo,
  FormSec,
  FormWrapper,
  SignupContainer,
  StyledInput,
} from "../signup/Signup.style";
import { toast } from "react-toastify";

const ClientResetPass = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const [showPass, setShowPass] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleResetPassword = async (values) => {
    try {
      if (!formData.password || !formData.confirmPassword) {
        toast.error("Password fields cannot be empty");
        return;
      }

      if (formData.password !== formData.confirmPassword) {
        toast.error("Passwords do not match");
        return;
      }

      setSpinner(true);

      // Use API call like the existing reset password flow
      const resetEmail = localStorage.getItem("resetEmail");
      const response = await apiReq(API_ROUTES.updateUserPassword, "POST", {
        email: resetEmail,
        password: formData.password,
        role: "Client",
      });
      
      console.log("Response:", response);
      if (response.status === 200) {
        toast.success("Password reset successfully");
        localStorage.removeItem("resetEmail");
        navigate("/");
      } else {
        console.error("Password reset request failed:", response.statusText);
        toast.error("Password reset failed. Please try again.");
      }
    } catch (error) {
      console.error("Error during password reset:", error.message);
      toast.error("Error during password reset. Please try again.");
    } finally {
      setSpinner(false);
    }
  };

  return (
    <SignupContainer>
      <Formik
        initialValues={{
          password: "",
          confirmPassword: "",
          role: "Client",
        }}
        onSubmit={handleResetPassword}
      >
        <FormWrapper>
          <FormSec gridGap="30px">
            <FormLogo>
              <img src={Logo} alt="Logo" />
            </FormLogo>
            <LoginMessageWrapper>
              <h5>Change Password</h5>
              <p>Enter new Password</p>
            </LoginMessageWrapper>

            <ForgetPasswordWrapper>
              <FieldWrapper>
                <p>Password</p>
                <StyledInput
                  type={showPass ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleInputChange}
                />
                <h5 onClick={() => setShowPass(!showPass)}>
                  {showPass ? "HIDE" : "SHOW"}
                </h5>
                <ErrorMessage name="password" component="div" />
              </FieldWrapper>
              <FieldWrapper>
                <p>Confirm Password</p>
                <StyledInput
                  type={showPass ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                />
                <h5 onClick={() => setShowPass(!showPass)}>
                  {showPass ? "HIDE" : "SHOW"}
                </h5>
                <ErrorMessage name="confirmPassword" component="div" />
              </FieldWrapper>
            </ForgetPasswordWrapper>
            <Button
              text={
                spinner ? (
                  <SyncLoader color={"#FFFFFF"} size={8} />
                ) : (
                  "Reset Password"
                )
              }
              width="100%"
              fontSize="18px"
              disabled={spinner}
              onClick={() => {
                handleResetPassword();
              }}
            />
          </FormSec>
        </FormWrapper>
      </Formik>
      <AuthPicWrapper>
        <img src={Auth} alt="Auth" />
      </AuthPicWrapper>
    </SignupContainer>
  );
};

export default ClientResetPass;
